<template>
  <div class="m-pc-partner top-nav" id="sponsor" v-if="extras && extras.sponsor.display">
    <Title :key="1"
      v-if="extras.sponsorTitle.display == 1"
      :title="extras.sponsorTitle.model || title"
    />
    <div class="g-partner-content u-w1200">
      <div class="sponsor">
        <div class="sponsor-text">{{text}}
        </div>
        <div class="sponsor-img">
          <img :src="imgUrl" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/index/Title.vue";
import { URLS } from "fire-wind-water";

export default {
  components: {
    Title,
  },
  props: {
    sponsor: Object,
    extras: Object,
  },
  data() {
    return {
      text: "",
      imgUrl: "",
      title: "主办方介绍",
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    console.log("pc-sponsor", this.sponsor);
    if (this.sponsor.sponsorImg) {
      let mappingId = JSON.parse(this.sponsor.sponsorImg).mapId;

      this.imgUrl =
        window.config.api.ungateway.contentUrl + "?mappingId=" + mappingId;
    }
    this.text = this.sponsor.sponsorDesc || "";
  },
  methods: {},
};
</script>
<style scoped></style>
